import React, { useState, useEffect } from "react";
import { ROUTES } from "../../../../consts";
import { MinusIcon, PlusIcon } from "@heroicons/react/solid";
import { useTrackContext } from "../../../../hooks/useTrackContext";
import ProgressBar from "../../../ProgressiveBar";
import NewsletterPopup from "../../../NewsletterPopup";
import MiniCart from "../../../Cart/MiniCart";
import BottomSummary from "../../../BottomSummary";

const SelectSeatsRaces: React.FC = () => {
  const { dispatch, mainTrackSelection, productRenderedLocation, metaObjectMainTrackSectionConfig, appHostedAt } = useTrackContext();
  const { racesSeats, ageGroup } = mainTrackSelection;
  const [windowWidth, setWindowWidth] = useState<number>(window.innerWidth);
  const [previousRoute, setPreviousRoute] = useState<string>("/" + ROUTES.MAIN_TRACK.RACE_TYPE);
  const { seatsAndRacesSection } = metaObjectMainTrackSectionConfig;

  useEffect(() => {
    ageGroup === "12-15" || ageGroup === "Under 12" ? setPreviousRoute("/" + ROUTES.MAIN_TRACK.AGE_GROUP) : setPreviousRoute("/" + ROUTES.MAIN_TRACK.RACE_TYPE);
  }, [ageGroup, productRenderedLocation]);

  const handleRacePlus = () => {
    if (mainTrackSelection.racesSeats.numberOfRaces < seatsAndRacesSection.maxRaceQuantity) {
      dispatch({
        type: "SET_RACES_SEATS",
        payload: {
          selectedTrack: "MAIN_TRACK",
          racesSeats: {
            ...mainTrackSelection.racesSeats,
            numberOfRaces: mainTrackSelection.racesSeats.numberOfRaces + 1,
          },
        },
      });
    }
  };

  const handleRaceMinus = () => {
    dispatch({
      type: "SET_RACES_SEATS",
      payload: {
        selectedTrack: "MAIN_TRACK",
        racesSeats: {
          ...mainTrackSelection.racesSeats,
          numberOfRaces: Math.max(1, mainTrackSelection.racesSeats.numberOfRaces - 1),
        },
      },
    });
  };

  const handleSeatPlus = () => {
    if (mainTrackSelection.racesSeats.numberOfSeats < seatsAndRacesSection.maxSeatsQuantity) {
      dispatch({
        type: "SET_RACES_SEATS",
        payload: {
          selectedTrack: "MAIN_TRACK",
          racesSeats: {
            ...mainTrackSelection.racesSeats,
            numberOfSeats: mainTrackSelection.racesSeats.numberOfSeats + 1,
          },
        },
      });
    }
  };

  const handleSeatMinus = () => {
    dispatch({
      type: "SET_RACES_SEATS",
      payload: {
        selectedTrack: "MAIN_TRACK",
        racesSeats: {
          ...mainTrackSelection.racesSeats,
          numberOfSeats: Math.max(1, mainTrackSelection.racesSeats.numberOfSeats - 1),
        },
      },
    });
  };

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <ProgressBar maxValue={100} currentValue={windowWidth <= 768 ? 48 : 65} />
      {productRenderedLocation === "external" && <MiniCart />}
      {/* <span className="tw-block tw-text-[18px] lg:tw-text-[24px] tw-text-[#F609FF] tw-font-[700] tw-mt-[30px] tw-text-center">Main Track</span> */}
      {/* <div className="tw-text-white tw-text-center tw-text-[24px] tw-font-extrabold">
        {seatsAndRacesSection.mainTitle ? seatsAndRacesSection.mainTitle : "Select your Seats and Races"}
      </div> */}

      <div className="tw-container tw-mx-auto">
        <div
          className={`tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 ${
            appHostedAt && appHostedAt === "bosshunting" ? "tw-gap-[30px]" : "tw-gap-[30px] lg:tw-gap-[160px]"
          } tw-my-[30px] lg:tw-my-[160px]`}
        >
          <div className="tw-max-w-[455px] tw-w-full tw-mx-auto lg:tw-mx-0 lg:tw-ml-auto">
            <div className="tw-text-white tw-text-center">
              <span className="tw-text-[20px] lg:tw-text-[25px] tw-font-[700]">{seatsAndRacesSection.seatsTitle ? seatsAndRacesSection.seatsTitle : "Seat(s)"}</span>
              <div className="tw-flex tw-justify-center tw-mt-[20px]">
                <div className="tw-flex tw-items-center tw-gap-[30px]">
                  <span
                    className={`tw-rounded-full tw-p-[5px] hover:tw-cursor-pointer ${racesSeats.numberOfSeats <= 1 ? "tw-bg-[#555758]" : "tw-bg-[#9D62FE]"}`}
                    onClick={handleSeatMinus}
                  >
                    <MinusIcon className="tw-w-[35px] tw-h-[35px]" />
                  </span>
                  <span className="tw-text-[30px] tw-font-bold tw-border-[2px] tw-rounded-[15px] tw-border-[#EBECEF] tw-bg-[#393B41] tw-py-[4px] tw-px-[60px]">
                    {racesSeats.numberOfSeats}
                  </span>
                  <span
                    className={`tw-rounded-full tw-p-[5px] hover:tw-cursor-pointer ${
                      racesSeats.numberOfSeats === seatsAndRacesSection.maxSeatsQuantity ? "tw-bg-[#555758]" : "tw-bg-[#9D62FE]"
                    }`}
                    onClick={handleSeatPlus}
                  >
                    <PlusIcon className="tw-w-[35px] tw-h-[35px]" />
                  </span>
                </div>
              </div>
              {seatsAndRacesSection && (
                <p
                  className={`tw-text-white tw-text-[18px] tw-font-[400] tw-text-center ${
                    appHostedAt && appHostedAt === "bosshunting" ? "tw-p-[10px] lg:tw-px-[20px]" : "tw-max-w-[375px] tw-w-full"
                  } tw-mx-auto tw-mt-[24px] lg:tw-mt-[30px]`}
                  style={appHostedAt && appHostedAt === "bosshunting" ? { textDecoration: "none", width: "unset", height: "unset", margin: 0, maxWidth: "unset" } : {}}
                >
                  {ageGroup === "Under 12" && seatsAndRacesSection.underTwelveSeatsDescription}
                  {ageGroup === "12-15" && seatsAndRacesSection.twelveToFifteenSeatsDescription}
                  {ageGroup === "16+" && seatsAndRacesSection.sixteenPlusSeatsDescription}
                </p>
              )}
            </div>
          </div>
          <div className="tw-max-w-[455px] tw-w-full tw-mx-auto lg:tw-mx-0 lg:tw-mr-auto">
            <div className="tw-text-white tw-text-center">
              <span className="tw-text-[20px] lg:tw-text-[25px] tw-font-[700]">{seatsAndRacesSection.raceTitle ? seatsAndRacesSection.raceTitle : "Race(s)"}</span>
              <div className="tw-flex tw-justify-center tw-mt-[20px]">
                <div className="tw-flex tw-items-center tw-gap-[30px]">
                  <span
                    className={`tw-rounded-full tw-p-[5px] hover:tw-cursor-pointer ${racesSeats.numberOfRaces <= 1 ? "tw-bg-[#555758]" : "tw-bg-[#9D62FE]"}`}
                    onClick={handleRaceMinus}
                  >
                    <MinusIcon className="tw-w-[35px] tw-h-[35px]" />
                  </span>
                  <span className="tw-text-[30px] tw-font-bold tw-border-[2px] tw-rounded-[15px] tw-border-[#EBECEF] tw-bg-[#393B41] tw-py-[4px] tw-px-[60px]">
                    {racesSeats.numberOfRaces}
                  </span>
                  <span
                    className={`tw-rounded-full tw-p-[5px] hover:tw-cursor-pointer ${
                      racesSeats.numberOfRaces === seatsAndRacesSection.maxRaceQuantity ? "tw-bg-[#555758]" : "tw-bg-[#9D62FE]"
                    }`}
                    onClick={handleRacePlus}
                  >
                    <PlusIcon className="tw-w-[35px] tw-h-[35px]" />
                  </span>
                </div>
              </div>
              {seatsAndRacesSection.raceDescription && (
                <p
                  className={`tw-text-white tw-text-[18px] tw-font-[400] tw-text-center ${
                    appHostedAt && appHostedAt === "bosshunting" ? "tw-p-[10px] lg:tw-px-[20px]" : "tw-max-w-[375px] tw-w-full"
                  } tw-mx-auto tw-mt-[24px] lg:tw-mt-[30px]`}
                  style={appHostedAt && appHostedAt === "bosshunting" ? { textDecoration: "none", width: "unset", height: "unset", margin: 0, maxWidth: "unset" } : {}}
                >
                  {seatsAndRacesSection.raceDescription}
                </p>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="tw-w-full lg:tw-h-[126px] tw-p-[30px]">
        <div className="tw-flex tw-justify-center tw-items-center">
          <div
            className={`${
              productRenderedLocation === "external" ? "tw-container tw-mx-auto" : "container mx-auto"
            } tw-relative tw-flex tw-justify-end tw-items-center tw-gap-[15px] lg:tw-block`}
          >
            {" "}
            <NewsletterPopup />
          </div>
        </div>
      </div>
      <BottomSummary
        previousInfo={{ pageName: "Race Type", pagePath: previousRoute }}
        nextInfo={{ pageName: "Continue", pagePath: "/" + ROUTES.MAIN_TRACK.DATE_TIME, isActive: true }}
      />
    </>
  );
};

export default SelectSeatsRaces;
